export class ModuleAccessPermission {
    public Contacts: boolean = false;
    public Affiliate: boolean = false;
    public Billing: boolean = false;
    public Strategy: boolean = false;
    public Reporting: boolean = false;
    public Company: boolean = false;
    //Add new module here to access
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/models/module-access-permission.model.ts